module.exports = __webpack_public_path__ + "img/speaker-02.7d79ee51.svg";